import { useMemo } from "react"

import { Palette } from "@mui/material"

import { CatalogItemsConditionCount } from "../CatalogItemsConditionCount"

import * as Styled from "./CatalogItemsGrading.styled"

export function CatalogItemsGrading(props: CatalogItemsGradingProps) {

    const {
        activeConditionFilters = [],
        catalogItemsGradingSettings,
        className,
        count,
        onConditionFiltersChanged,
        type = "count",
        ...rest
    } = props

    const orderedCount = useMemo(() => {
        return Object.entries(count)
            .sort(([keyA], [keyB]) => Number(keyB) - Number(keyA))
    }, [count])

    const totalCount = useMemo(() => Object.values(count).reduce((acc, v) => acc + v, 0), [count])
    const catalogItemsGradingBarItemsCount = Object.values(count).filter(c => c && c > 0).length
    const catalogItemsGradingBarItems = useMemo(() => {
        return orderedCount
            .filter(([_, value]) => !!value)
            .map(([dataKey, dataValue], index) => {
                const color = catalogItemsGradingSettings[dataKey].color;
                const width = dataValue / totalCount * 100;

                return <Styled.SignsGradingBarItem
                    color={color as keyof Palette}
                    key={`signsGradingItem-${dataKey}`}
                    index={index}
                    width={width}
                    style={{ width: `${width}%` }}
                />
            })
    }, [orderedCount, catalogItemsGradingSettings, totalCount])

    const catalogItemCounts = useMemo(() => orderedCount.map(([dataKey, dataValue]) => {
        const color = catalogItemsGradingSettings[dataKey].color
        const label = catalogItemsGradingSettings[dataKey].label

        return <CatalogItemsConditionCount
            color={color}
            count={dataValue}
            key={`catalogItemCount-${dataKey}`}
            label={label}
            onClick={() => onConditionFiltersChanged(dataKey)}
            selected={activeConditionFilters.includes(parseInt(dataKey))}
            type={type}
        />

    }), [activeConditionFilters, orderedCount, onConditionFiltersChanged, catalogItemsGradingSettings, type])

    return <div className={className} {...rest}>
        <Styled.Mask>
            <Styled.CatalogItemsGradingBarWrapper itemsCount={catalogItemsGradingBarItemsCount}>
                <Styled.EmptyBarItem />
                {catalogItemsGradingBarItems}
            </Styled.CatalogItemsGradingBarWrapper>
        </Styled.Mask>
        <Styled.CatalogItemsCountsWrapper>
            {catalogItemCounts}
        </Styled.CatalogItemsCountsWrapper>
    </div>
}

type CatalogItemsGradingProps = {
    activeConditionFilters?: number[],
    className?: string,
    catalogItemsGradingSettings: {
        [key: string]: {
            backgroundColor?: string,
            color: string,
            label: string,
        }
    },
    count: {
        [key: string]: number,
    },
    onConditionFiltersChanged: (_conditionFilter: string | number) => void,
    type?: "distance" | "count",
}   
